import { Exo_2, Sofia_Sans, Alegreya, Sofia_Sans_Condensed } from 'next/font/google';
import { alpha } from '@mui/material/styles';

const displayFont = Exo_2({
  weight: ['200', '600'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap',
  preload: false,
});

const bodyFont = Sofia_Sans({
  weight: ['400', '800'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap',
  preload: false,
});

const helpFont = Alegreya({
  weight: ['400'],
  style: ['italic'],
  subsets: ['latin'],
  display: 'swap',
  preload: false,
});

const condensedFont = Sofia_Sans_Condensed({
  weight: ['400'],
  style: ['normal'],
  subsets: ['latin'],
  display: 'swap',
  preload: false,
});

const typography = {
  fontFamily: bodyFont.style.fontFamily,
  h1: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '2.6rem !important',
    fontWeight: 200,
    letterSpacing: '-0.06rem',
    color: '#FFFFFF',
  },
  h2: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '2.3rem !important',
    fontWeight: 200,
    letterSpacing: '-0.02rem',
    color: '#FFFFFF',
  },
  h3: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '2rem !important',
    fontWeight: 200,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  h4: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '1.6rem !important',
    fontWeight: 200,
    letterSpacing: '0.02rem',
    color: '#FFFFFF',
  },
  h5: {
    fontFamily: helpFont.style.fontFamily,
    fontStyle: 'italic',
    fontSize: '1.25rem',
    fontWeight: 400,
    letterSpacing: '0.02rem',
    lineHeight: '1.3',
  },
  h6: {
    fontFamily: helpFont.style.fontFamily,
    fontStyle: 'italic',
    fontSize: '1.125rem',
    fontWeight: 400,
    letterSpacing: '0.02rem',
    lineHeight: '1.3',
  },
  subtitle1: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '1.3rem',
    lineHeight: '1.4',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  subtitle2: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '1.2rem',
    lineHeight: '1.3',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  condensed6: {
    fontFamily: condensedFont.style.fontFamily,
    fontSize: '1rem',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  condensed5: {
    fontFamily: condensedFont.style.fontFamily,
    fontSize: '1.2rem',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  condensed4: {
    fontFamily: condensedFont.style.fontFamily,
    fontSize: '1.4rem',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  body1: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '1rem',
    fontWeight: 400,
    letterSpacing: '0.01rem',
    color: 'rgb(227, 227, 227)',
  },
  body2: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 400,
    letterSpacing: '0.01rem',
    color: alpha('rgb(227, 227, 227)', 0.7),
  },
  button: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '1rem',
    fontWeight: 600,
    letterSpacing: '0.02rem',
  },
  caption: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '0.75rem',
    fontWeight: 400,
    letterSpacing: '0.04rem',
  },
  overline: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '0.75rem',
    fontWeight: 400,
    letterSpacing: '0.06rem',
  },
};

export default typography;
